import i18n from '../i18n';

const LOCALE_MAP = {
  es: 'es-AR',
  en: 'en-US',
  pt: 'pt-BR',
};

/**
 * Format a number as Argentine currency (ARS). Shows up to 2 decimals only when
 * the value has them (QA 2026-09-13: admin showed $133 for a $133.10 item).
 * Locale adapts to the current UI language so number separators
 * match user expectations (es-AR: $19.299, en-US: ARS 19,299, pt-BR: ARS 19.299).
 */
export const formatCurrency = (value) => {
  const locale = LOCALE_MAP[i18n.language] || 'es-AR';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value || 0);
};

/**
 * Format a price in an explicit currency, showing the currency CODE
 * (e.g. "ARS 69.000", "USD 69", "BRL 349") so it is never ambiguous —
 * a bare "$69" reads as USD to AR users when the real price is ARS 69.000.
 * Number separators adapt to the current UI language (NER-2444).
 */
export const formatPriceWithCurrency = (value, currency = 'ARS') => {
  const locale = LOCALE_MAP[i18n.language] || 'es-AR';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency || 'ARS',
    currencyDisplay: 'code',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value || 0);
};
